'use client'

import { useState } from 'react'
import { Check, Copy } from 'lucide-react'
import { track } from '@/lib/analytics/track'

interface CopyPromptButtonProps {
  prompt: string
  slug: string
  category: string
}

export function CopyPromptButton({
  prompt,
  slug,
  category,
}: CopyPromptButtonProps) {
  const [copied, setCopied] = useState(false)

  async function handleCopy() {
    try {
      await navigator.clipboard.writeText(prompt)
      setCopied(true)
      track('gpt_image_2_prompt_copy', { slug, category })
      window.setTimeout(() => setCopied(false), 1800)
    } catch {
      // Clipboard API blocked — silently no-op; the prompt is still visible.
    }
  }

  return (
    <button
      type="button"
      onClick={handleCopy}
      className="inline-flex h-9 flex-1 items-center justify-center gap-1.5 rounded-md border border-border bg-background px-3 text-sm font-medium text-foreground/80 transition-colors hover:border-foreground/30 hover:text-foreground"
      aria-label={copied ? 'Prompt copied' : 'Copy prompt'}
    >
      {copied ? (
        <>
          <Check className="h-4 w-4" />
          Copied
        </>
      ) : (
        <>
          <Copy className="h-4 w-4" />
          Copy prompt
        </>
      )}
    </button>
  )
}
